var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63603 5.63658C5.32814 5.94447 5.32814 6.44828 5.63603 6.75617L7.31541 8.43555L5.63603 10.1149C5.32814 10.4228 5.32814 10.9266 5.63603 11.2345C5.94391 11.5424 6.44773 11.5424 6.75561 11.2345L8.43499 9.55513L10.1144 11.2345C10.4223 11.5424 10.9261 11.5424 11.234 11.2345C11.5418 10.9266 11.5418 10.4228 11.234 10.1149L9.55458 8.43555L11.234 6.75617C11.5418 6.44828 11.5418 5.94447 11.234 5.63658C10.9261 5.3287 10.4223 5.3287 10.1144 5.63658L8.43499 7.31596L6.75561 5.63658C6.44773 5.3287 5.94391 5.3287 5.63603 5.63658ZM2.83706 2.83762C-0.252992 5.92767 -0.252992 10.9434 2.83706 14.0335C5.92712 17.1235 10.9429 17.1235 14.0329 14.0335C17.123 10.9434 17.123 5.92768 14.0329 2.83762C10.9429 -0.252437 5.92712 -0.252438 2.83706 2.83762ZM12.9133 12.9139C10.4446 15.3826 6.42534 15.3826 3.95665 12.9139C1.48796 10.4452 1.48796 6.42589 3.95665 3.9572C6.42534 1.48852 10.4446 1.48852 12.9133 3.9572C15.382 6.42589 15.382 10.4452 12.9133 12.9139Z",
    fill: "#D22630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.fa288e8f550f66587f539d23f35a8af3.svg";
export { ForwardRef as ReactComponent };